import React from 'react';
import './projects.scss';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Button,
  Pager,
  Paging,
  FilterRow,
  Lookup,
  Editing,
  Selection,
  HeaderFilter,
  Item,
  Toolbar,
  SearchPanel,
  Form as GridForm
} from 'devextreme-react/data-grid';

import {Button as ToolbarButton} from 'devextreme-react/button';
import { useState, useEffect, useCallback} from "react";

import {Popup as ExtPopup} from 'devextreme-react/popup';

import { useAuth } from  '../../contexts/auth'; 
import {Logout} from '../../globals';
import notify from 'devextreme/ui/notify';

const debug = process.env.ENTITY_DEBUG;

export default function CheckListTab(props) {

    const projectId = props.projectId;
    const { user } = useAuth(); 
    if (!user) 
        Logout();

    const [commesse, setCommesse] = useState({});
    const [checkList, setCheckList] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedIds, setSelectedIds] = useState();

    const [isPopupVisible2, setPopupVisibility2] = useState(false);
    const togglePopup2 = () => {
        setPopupVisibility2(!isPopupVisible2);
    };

    const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CheckListEntry'
    const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CheckList'
    const filterPayload = { 
        commessa: projectId
    };
    
    var checkListDataGridRef = React.createRef();

    const remoteDataSource = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/Find',
        onBeforeSend: (method, ajaxOptions) => {
            if (method === "load" ) {           
                var payload = ajaxOptions.data;
                payload.values = JSON.stringify(filterPayload);
                ajaxOptions.data = payload;          
            }   
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
            ;
        },
        insertUrl: serviceUrl + '/InsertAction',
        updateUrl:serviceUrl + '/UpdateAction',
        deleteUrl: serviceUrl + '/DeleteAction'
          
    });

    
    const remoteDataSource2 = createStore({
        key: 'id',
        loadUrl: serviceUrl3 + '/GetAction',
        onBeforeSend: (method, ajaxOptions) => {  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
            ;
        },
        insertUrl: serviceUrl3 + '/InsertAction',
        updateUrl:serviceUrl3 + '/UpdateAction',
        deleteUrl: serviceUrl3 + '/DeleteAction'
          
    });

    useEffect(() => {
        
        const fetchData = async () => {
    
        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CheckList';
        var newUrl =  newServiceUrl + "/GetAction";
        const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
        var newUrl3 =  newServiceUrl3 + "/GetOpen";
        try {
    
            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${user.token}`
                }
            };
            
            const response = await fetch(newUrl,requestOptions);
            const json = await response.json();
            if (debug === 1)
                console.log(json);
            setCheckList(json);

            const response3 = await fetch(newUrl3,requestOptions);
            const json3 = await response3.json();
            if (debug === 1)
                console.log(json3);
            setCommesse(json3);

        } catch (error) {
          console.log("error", error);
        }
      };
        
        fetchData();
      }, []);


    const getStringId = (row) => `${row.id}`;
    const getSelectedIds = (selectedRowsData) => (selectedRowsData.length ? selectedRowsData.map(getStringId).join(';') : '');
    
    const onSelectionChanged = useCallback(
        ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
        setSelectedRowKeys(changedRowKeys);
        setSelectedIds(getSelectedIds(selectedRowsData));
        }, [],
    );

    function onRowUpdating(e) {
        e.newData.updateBy = user.name;
      };

    async function onConfirmButtonClick() {
   
        const movsPayload = { 
            entityId: projectId,
            stringIds: selectedIds
        };
    
        setPopupVisibility2(!isPopupVisible2);
        const url = serviceUrl + "/AddCheckList"; 
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(movsPayload),
            headers: {
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${this.state.loggedUser.token}`
            }
        };
     
        return fetch(url, requestOptions)
          .then(response => {
            if(response.ok) return response.json();
            return null;
          })
          .then(data => { 

            setTimeout(() => { 
                notify(data.message, data.success ? 'success' : 'error', 2000);       
            }, 100);
            if(checkListDataGridRef !== null)
                checkListDataGridRef.instance().refresh();   
            setSelectedIds('');
            setSelectedRowKeys([]);

          })
          .catch(error => { notify(error, 'error', 5000); }); 
    }


    const renderContent2 = () =>  {
    return (
        <>
        { selectedIds !== '' &&
            <p>Id selezionati <b> {selectedIds}</b></p>
        }
        
        <DataGrid id="grid-popup"
            ref={ref => checkListDataGridRef = ref}
            className={'dx-card wide-card'}
            dataSource={remoteDataSource2}
            showBorders={true}

            focusedRowEnabled={true}
            defaultFocusedRowIndex={0}
            selectedRowKeys={selectedRowKeys}
            onSelectionChanged={onSelectionChanged}
        >
            <Pager
                showPageSizeSelector={true}
                //allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
                showInfo={true}
            />
            <Paging defaultPageSize={10} />
            <Selection mode="multiple"  selectAllMode="page" showCheckBoxesMode="always"/>

            <Toolbar>
                <Item location="after">
                <ToolbarButton className="offer-toolbar"
                    icon='todo'
                    hint='Conferma'
                    disabled={selectedIds === ''}
                    onClick={onConfirmButtonClick} 
                />
                </Item>
                <Item location="after">
                <ToolbarButton className="offer-toolbar"
                    icon='revert'
                    hint='Annulla'
                    onClick={cancel} 
                />
                </Item>    
                <Item name="searchPanel" className="offer-toolbar"/>
            </Toolbar>
            <Column dataField="id" width={60}/>
            <Column dataField="codice" visible={false}/>
            <Column dataField="descrizione"/>
        </DataGrid>
        <p></p>
        </>         
    )
    }

    
    function cancel()  {
        setPopupVisibility2(!isPopupVisible2);
        setSelectedIds('');
        setSelectedRowKeys([]);
    };

    return (
        <React.Fragment>
        <h2 className={'content-block'}></h2>
        <div className={'content-block'}>
            <div className={'dx-card responsive-paddings'}>
                
            <DataGrid
                dataSource={remoteDataSource}
                focusedRowEnabled={true}
                //onInitNewRow={handleInitNewRow}
                //onSelectionChanged={onRowSelectionChanged}
                onRowUpdating={onRowUpdating}
                dateSerializationFormat= {'yyyy-MM-dd'}
            >
            <SearchPanel visible={true} width={240} placeholder="Cerca..." />
            <HeaderFilter visible={true} />
            <Toolbar>
              <Item location="before">
                <ToolbarButton className="offer-toolbar"
                  icon='increaseindent'
                  hint='Aggiungi Check List'
                  onClick={togglePopup2}
                />
              </Item>
              <Item name="searchPanel" className="offer-toolbar"/>
            </Toolbar>
            <Selection mode="single" />
            <Editing
              mode="row"
              useIcons={true}
              allowAdding={true}
              allowDeleting={true}
              allowUpdating={true}     
            >
             
            </Editing>
            <Column dataField="id" visible={false}/>
           
            <Column dataField="commessaId" caption="Commessa" width={140} allowEditing={false} visible={false}>
              <Lookup dataSource={commesse} valueExpr="id" displayExpr="nomeEsteso" />
            </Column>
            <Column dataField="checkListId" caption="CheckList Entry" visible={true} allowEditing={false}>
              <Lookup dataSource={checkList} displayExpr="descrizione" valueExpr="id" />
            </Column>
            <Column dataField="completato"/>
            <Column dataField="updateDate" caption ="Aggiornato il" dataType="date" format= {'dd/MM/yyyy'} allowEditing={false}/>
            <Column dataField="updateBy" caption ="Aggiornato da" allowEditing={false}/>
      
          
          </DataGrid>  
    
            <div>
                <ExtPopup
                width={800}
                height={640} 
                showTitle={true}
                title="Copia Check List"
                visible={isPopupVisible2}
                hideOnOutsideClick={true}
                onHiding={togglePopup2}
                contentRender={renderContent2}
                > 
                </ExtPopup> 
            </div>
    
        </div>
    </div>
    </React.Fragment>
    
)};